



















import Vue from 'vue';

enum State {
    NotPressed = 'NotPressed',
    Waiting = 'Waiting',
    Pressed = 'Pressed',
}

export default Vue.extend({
    name: 'device-keyboard',

    data(): {
        state: State,
        key?: KeyboardEvent,
    } {
        return {
            state: State.NotPressed,
            key: undefined,
        };
    },

    methods: {
        waitForKey() {
            this.state = State.Waiting;
            const kp = (e: KeyboardEvent) => {
                if (e.key === 'Control' || e.key === 'Alt' || e.key === 'Shift' || e.key === 'Dead') {
                    document.addEventListener('keydown', kp, { once: true });
                } else {
                    this.key = e;
                    this.state = State.Pressed;
                    this.$emit('key-pressed', this.parseKey(e));
                    e.preventDefault();
                }
            };
            document.addEventListener('keydown', kp, { once: true });
        },

        cancel() {
            this.state = State.NotPressed;
            this.key = undefined;
        },

        parseKey(e: KeyboardEvent) {
            let code;
            if (e.key.length === 1) {
                code = e.key.charCodeAt(0);
            } else {
                switch (e.key) {
                    case 'Insert':     code = 0xf0; break;
                    case 'Home':       code = 0xf1; break;
                    case 'End':        code = 0xf2; break;
                    case 'PageUp':     code = 0xf3; break;
                    case 'PageDown':   code = 0xf4; break;
                    case 'ArrowRight': code = 0xf5; break;
                    case 'ArrowLeft':  code = 0xf6; break;
                    case 'ArrowUp':    code = 0xf7; break;
                    case 'ArrowDown':  code = 0xf8; break;
                    default:           // noinspection JSDeprecatedSymbols
                        code = e.keyCode; break;
                }
            }
            if (e.shiftKey)
                code |= (1 << 9);
            if (e.ctrlKey)
                code |= (1 << 10);
            return code;
        },
    },

    computed: {
        keypressed(): string {
            if (this.key === undefined)
                return 'None';
            let s = `${this.key!.key} (0x${this.parseKey(this.key!).toString(16).toUpperCase()})`;
            if (this.key!.shiftKey)
                s = `Shift + ${s}`;
            if (this.key!.ctrlKey)
                s = `Ctrl + ${s}`;
            return s;
        },
    },
});
